"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  accentFill: {
    fill: theme.palette.primary.main
  }
}));
const ReturnIcon = props => {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 310 110",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "Railway_Layout_1_",
      opacity: "0.25",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "41.325",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "153.9",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Station_3",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            cx: "266.476",
            cy: "53.827",
            r: "17.802"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Track",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            y: "47.657",
            fillRule: "evenodd",
            clipRule: "evenodd",
            width: "310",
            height: "13.509"
          })
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Return_1_",
      className: classes.accentFill,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "Shape_4",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M266.853,12.342H42.357v17.645h224.496 c13.218,0,23.938,10.714,23.938,23.934c0,13.219-10.72,23.934-23.938,23.934H80.777V65.251L43.668,86.675l35.764,20.647h1.345 V95.498h186.076c22.965,0,41.579-18.617,41.579-41.577C308.432,30.958,289.818,12.342,266.853,12.342z"
          })
        })
      })
    })]
  });
};
var _default = exports.default = ReturnIcon;